import { Injectable, Pipe, PipeTransform } from "@angular/core";
@Injectable({ providedIn: "root" })
@Pipe({
  name: "price",
})
export class PricePipe implements PipeTransform {
  constructor() {}

  transform(price: number | string): string {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
}
